(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurvePointDeleteController',YieldCurvePointDeleteController);

    YieldCurvePointDeleteController.$inject = ['$uibModalInstance', 'entity', 'YieldCurvePoint'];

    function YieldCurvePointDeleteController($uibModalInstance, entity, YieldCurvePoint) {
        var vm = this;

        vm.yieldCurvePoint = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            YieldCurvePoint.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
